export default {
  getHead: () => {
    return [{name: '학교명'}, {name: '안전담당자'}, {name: '보건담당자'}, {name: '작성일'}]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).companyName // 사업장명
      case 1: return func.getContent(value).inputC_1 // 안전담당자
      case 2: return func.getContent(value).inputD_1 // 보건담당자
      case 3: return func.getCreatedDate(value.created_at) // 등록일
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'created_at'
      nav.dateBegin = 'nav.value.created_at.sDate'
      nav.dateEnd = 'nav.value.created_at.eDate'
    }
    return { searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {
    switch (nav.value.searchType) {
    case '학교명': return ['content$body.companyName*%[:default_skw]%']
    case '안전담당자': return ['content$body.inputC_1*%[:default_skw]%']
    case '보건담당자': return ['content$body.inputD_1*%[:default_skw]%']
    case '소속명': return ['content$body.inputC_2*%[:default_skw]%']
    case '부서명': return ['content$body.stdInfo.com_name*%[:default_skw]%']
    }
  },
}
